class TravelerLog {
  constructor({
    document,
    log,
    element,
  }) {
    this.document = document
    this.log = log.forClass("TravelerLog")
    this.element = element
  }

  render(game, change) {
    const logger = this.log.method("render", { change })
    let message = null;
    if (!change.isMoved()) {
      message = change.messageString()
      if (!message && change.newX) {
        const oldTile = game.gameMap.terrainTileAt(change.newX, change.newY)
        message = `BLOCKED by ${oldTile.human_name}`
      }
    }

    if (message) {
      logger.addDetails({ message })
      const $travelerLogList = this.element.querySelector("[data-log] ol")
      const $travelerLogEntries = this.element.querySelectorAll("[data-log] ol li")

      if ($travelerLogEntries.length > 50) {
        $travelerLogList.removeChild($travelerLogEntries[0])
      }
      $travelerLogEntries[$travelerLogEntries.length-1].innerText = message
      $travelerLogList.appendChild(this.document.createElement("li"))
      this.element.scrollTop = this.element.scrollHeight
    }
    logger.end()
  }

}

export default TravelerLog
